import React, { FunctionComponent } from 'react';
import { IBufferedRange } from '@24i/player-base';
import { BufferedRange } from './styled';
import { IBuffered } from '../../../Timeline/types';

const PERCENT = 100;

export const Buffered: FunctionComponent<IBuffered> = ({
    playerInstance,
    className = '',
    duration,
    style = null,
}) => {
    const bufferedRanges = playerInstance?.bufferedRanges || [];
    const result = bufferedRanges.map((buffered: IBufferedRange) => {
        if (!buffered) return null;
        const { start, end } = buffered;
        const fromLeft = (start / duration) * PERCENT;
        const length = (end / duration) * PERCENT - fromLeft;
        return !Number.isNaN(start) && !Number.isNaN(end) ? (
            <BufferedRange
                className={`${className} Buffered`}
                data-test="Buffered-Range"
                key={`BufferedRange-${start}`}
                {...{ fromLeft, length, style }}
            />
        ) : null;
    });
    return <div>{result}</div>;
};
